export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9796.24feb86d.jpg";